import { green, red } from '@mui/material/colors';

export const calculateHealthBackgroundColor = (isHealthy) => {
    return isHealthy ? green[500] : red[400];
};

export const FULL_DISPLAY_CHIP_STYLE = (isHealthy) => ({
    width: '60%',
    paddingLeft: '0.5rem',
    backgroundColor: calculateHealthBackgroundColor(isHealthy),
});

export const COMPACT_CHIP_STYLE = (isHealthy) => ({
    width: '1.25rem',
    height: '1.25rem',
    backgroundColor: calculateHealthBackgroundColor(isHealthy),
    borderRadius: '50%',
    position: 'relative',
    padding: 0,
    '& .MuiChip-icon': {
      width: '0.75rem',
      height: '0.75rem',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      margin: 0,
    },
  });
